export default error =>
    import(/* webpackChunkName: "stacktrace-js" */ "stacktrace-js").then(m =>
        m.default.fromError(error)
    )
